import { Type } from 'class-transformer';
import { Address } from '@31third/common';
import {
  Allowance,
  BaseEntityModel,
  RebalancingHistoryState,
  Trade,
  TransformBigInt,
} from 'common';

export class Rebalancing implements BaseEntityModel {
  public id: string;
  public baseValueInUsd: number;
  public sellValueInUsd: number;
  public estimatedValueLossInUsd: number;
  public estimatedTargetValueInUsd: number;
  public estimatedReceiveValueInUsd: number;
  public minReceiveValueInUsd: number;
  public estimatedImpact: number;
  public maxImpact: number;
  @TransformBigInt()
  public estimatedGasFees: bigint;
  public estimatedGasFeesInUsd: number;
  public estimatedProtocolFeesInUsd: number;
  @Type(() => Allowance)
  public allowances: Allowance[];
  @Type(() => Trade)
  public trades: Trade[];
  public expirationTimestamp: Date;
  public earliestRefreshQuotesTimestamp: Date;
  public suggestedRefreshQuotesTimestamp: Date;
  public creationDate: Date;
  public modificationDate: Date;

  // batch trade
  public txHandler: Address | undefined;
  public txData: string | undefined;
  @TransformBigInt()
  public txValue: bigint | undefined;
  public txHash: string | undefined;
  public executable: boolean;

  // history
  public state: RebalancingHistoryState;

  public isAllowanceDone(): boolean {
    return this.allowances?.find(allowance => !allowance.done) === undefined;
  }

  public isExpired(): boolean {
    return (
      this.expirationTimestamp &&
      this.expirationTimestamp.getTime() < new Date().getTime()
    );
  }

  public getTimeToExpiration(): number {
    if (this.expirationTimestamp) {
      const time = this.expirationTimestamp.getTime() - new Date().getTime();
      return time > 0 ? time : 1;
    }
    return 0;
  }

  public getTimeToSuggestedRefresh(): number {
    if (this.suggestedRefreshQuotesTimestamp) {
      const time =
        this.suggestedRefreshQuotesTimestamp.getTime() - new Date().getTime();
      return time > 0 ? time : 1;
    }
    return 30_000;
  }
}
